module.exports = __webpack_public_path__ + "static/media/banner1.9e7fe293.jpg";